import './micro/public-path';
import Vue from 'vue'
import App from './App.vue'
import event from '@/util/event'
import trigger from '@/util/trigger'
// import VueRouter from 'vue-router';
import {
  runFunction
} from '@/util/handlerElementBindingEvents'
import GroupBox from '@/editorComponents/GroupBox'
import ElementBox from '@/editorComponents/ElementBox'
Vue.component('GroupBox', GroupBox)
Vue.component('ElementBox', ElementBox)
// let router = null;
let instance = null;
Vue.prototype.$instance = {};
Vue.use(trigger);
Vue.config.productionTip = false;
Vue.prototype.$EventBus = new Vue({
  data() {
    return {
      viewportList: null, // 蓝图事件流数据
      apiVersion: null, // api 版本号
      canvasHeight: null, // 画布高度
      canvasWidth: null, // 画布宽度
      dynamicServer: null, // 动态图表
      projectId: null, // 项目ID
      pageIndex: null, // 当前页面索引
      sceneRender: null, // 场景实例
      renderIsReady: false, // 场景加载完成
      sceneOption: null, // 场景配置
      panelFilters: null // 全局过滤器
    };
  }
});
function render(props = {}) {
  const { container } = props;
  // router = new VueRouter({
  //   base: window.__POWERED_BY_QIANKUN__ ? '/app-vue/' : '/',
  //   // mode: 'history',
  //   router
  // });

  instance = new Vue({
    // router,
    render: h => h(App)
  }).$mount(container ? container.querySelector('#app') : '#app');
}

// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
  render();
}

export async function bootstrap() {
  console.log('app bootstraped');
}
export async function mount(props) {
  console.log('props from main framework', props);
  render(props);
  window.currentHost = (props && props.guiHost) || ''
  const panelUrl = (props && props.publicPanelUrl) || '';
  window.publicPanelUrl = panelUrl.indexOf('panel.html') !== -1 ? panelUrl.substring(0, panelUrl.length - 10) : panelUrl.substring(0, panelUrl.length - 15)
  if (props && props.apiFunc && props.apiFunc.startApiFunc) {
    window.startApiFunc = props.apiFunc.startApiFunc;
    instance.$blueMap && instance.$blueMap.trigger({
      nodeType: 'listen-all',
      pluginId: '',
      dataKey: 'listen',
      eventData: {
        value: 'APIAlready',
        data: null,
        event: null
      }
    })
  }
  props.onGlobalStateChange((state, prev) => {
    console.log('main stage change', state);
    if (state && state.triggerType === 'paas' && state.targetModule === 'gui-preview') {
      triggerListenApi(state.data)
    }
  })
}
function triggerListenApi(data) {
  if (data.type === 'listenApi') {
    console.log(data, '接收paas监听场景数据触发trigger事件');
    instance.$blueMap && instance.$blueMap.trigger({
      nodeType: 'listen-all',
      pluginId: '',
      dataKey: 'listen',
      eventData: {
        value: data.data,
        data: null,
        event: null
      }
    })
  }
}
export async function unmount() {
  instance.$destroy();
  instance.$el.innerHTML = '';
  instance = null;
  // router = null;
}
// 全局事件监听
// 采用低优先级监听 ajax*** 事件，以便其他地方可以拦截取消
event.on({
  ajax401() {
    // alert('权限不足')
  },

  ajax403() {
    // alert('权限不足')
  },

  ajax400() {
    // alert('参数错误')
  }
}, false)
// 监听函数运行任务
event.on('runFunsTask', runFunction)

// const xe = new Vue({
//   render: h => h(App)
// }).$mount('#app')
// xe.$nextTick(() => {
//   xe.$blueMap.setVueInstance(xe)
// })
